import { Component } from '@angular/core';

@Component({
  selector: 'app-unlicensed',
  templateUrl: './unlicensed.component.html',
  styleUrls: ['./unlicensed.component.scss'],
})
export class UnlicensedComponent {}
